import ComboBox from '@components/ComboBox';
import DatePicker from '@components/DatePicker';
import DateTimepicker from '@components/DateTimePicker/DateTimePicker';
import SelectInput from '@components/SelectInput/SelectInput';
import TextInput from '@components/TextInput/TextInput';
import Timepicker from '@components/Timepicker';

export default {
  datepicker: DatePicker,
  timepicker: Timepicker,
  dateTimepicker: DateTimepicker,
  text: TextInput,
  select: SelectInput,
  comboBox: ComboBox
};
